import { Routes } from "@angular/router";
import { AuthGuard } from "src/app/core/guards/auth.guard";

export const TriggerManagementRoutes: Routes = [
  {
    path: "trigger-management",
    loadComponent: () =>
      import("./trigger-management/trigger-management.component").then(
        (m) => m.TriggerManagementComponent,
      ),
    canActivate: [AuthGuard],
    children: [
      {
        path: "",
        loadComponent: () =>
          import("./trigger-management-list/trigger-management-list.component").then(
            (m) => m.TriggerManagementListComponent,
          ),
      },
      {
        path: "add",
        loadComponent: () =>
          import("./trigger-management-form/trigger-management-form.component").then(
            (m) => m.TriggerManagementFormComponent,
          ),
      },
      {
        path: "view/:id",
        loadComponent: () =>
          import("./trigger-management-form/trigger-management-form.component").then(
            (m) => m.TriggerManagementFormComponent,
          ),
      },
      {
        path: "view/:id/items",
        loadComponent: () =>
          import("./trigger-item-form/trigger-item-form.component").then(
            (m) => m.TriggerItemFormComponent,
          ),
      },
      {
        path: "view/:id/items/:itemId",
        loadComponent: () =>
          import("./trigger-item-form/trigger-item-form.component").then(
            (m) => m.TriggerItemFormComponent,
          ),
      },
    ],
  },
];
